export const ENABLE_NEW_ENTITY_PAGES_ARTICLES_MODULE = 'ABACUS-485';
